import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey30, blue30, grey40, spacing8, spacing16, white, fontSize14 } from "@churchofjesuschrist/eden-style-constants";
import { Text6 } from "@churchofjesuschrist/eden-text";
/* An adaptation of https://www.lambdatest.com/blog/how-to-create-a-cross-browser-compatible-html-progress-bar/ */

const Progress = styled.div.withConfig({
  componentId: "sc-f0u66j-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
const Description = styled(Text6).withConfig({
  componentId: "sc-f0u66j-1"
})(["max-width:400px;text-align:center;color:", ";@media (min-width:320px){font-size:", ";}@media (min-width:480px){max-width:300px;width:50%;}"], grey40, fontSize14);
const BarWrapper = styled.div.withConfig({
  componentId: "sc-f0u66j-2"
})(["width:50%;max-width:300px;height:", ";display:inline-flex;position:relative;justify-content:center;", " + &{margin-block-start:", ";}&::after{content:\"\";position:absolute;z-index:1;top:0;left:0;right:0;bottom:0;border:1px solid ", ";border-radius:4px;}@media (min-width:320px){", " + &{margin-block-start:", ";}}"], spacing8, Description, spacing8, grey30, Description, spacing16);
const Bar = styled.progress.withConfig({
  componentId: "sc-f0u66j-3"
})(["-webkit-appearance:none;-moz-appearance:none;appearance:none;position:relative;height:100%;border:0;width:100%;max-width:300px;border-radius:4px;background-color:", ";color:", ";overflow:hidden;&::-webkit-progress-bar{background-color:", ";border:0;height:100%;}&::-webkit-progress-value{background-color:", ";position:relative;z-index:2;border:0;height:100%;border-top-right-radius:0;border-bottom-right-radius:0;}&::-moz-progress-bar{background-color:", ";margin-top:-1px;margin-left:-1px;z-index:2;border:0;height:10px;border-top-right-radius:0;border-bottom-right-radius:0;}@supports (-moz-appearance:none){div::after{display:none;}progress{box-shadow:0 0 0 1px ", ";}}"], white, blue30, white, blue30, blue30, grey30);

const ProgressBar = _ref => {
  let {
    value,
    max = 1,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Progress, props, children ? /*#__PURE__*/React.createElement(Description, null, children) : null, /*#__PURE__*/React.createElement(BarWrapper, null, /*#__PURE__*/React.createElement(Bar, {
    value: value,
    max: max
  })));
};

ProgressBar.propTypes = {
  /** A number between `0` and `max` representing the amount of work completed. If not present, the component will display as an "indeterminate" state. */
  value: PropTypes.number,

  /** A number greater than `0` representing the total work to be done */
  max: PropTypes.number,
  // Default is `1`,

  /** An explanation of why the user is waiting */
  children: PropTypes.node
};
export default ProgressBar;